import { Box, useTimeout } from "@sembark-travel/ui-base"
import { arrayMutators, Form, useFormState } from "@sembark-travel/ui-form"
import { useCallback, useEffect, useRef } from "react"
import { ServiceWiseInputFieldsArray } from "./ServiceWiseInputFieldsArray"
import { TTripDestination } from "../TripDestinations"
import { TVisaServiceInQuote } from "./store"

interface CalculatePriceFormProps {
	onChange?: (value: TVisaServiceInQuote) => void
	initialData: TVisaServiceInQuote
	tripDestinations: Array<TTripDestination>
	totalPax: number
	isEditMode?: boolean
	showBookedPrices?: boolean
	startDate: string
}

export function CalculatePriceForm({
	onChange,
	initialData,
	tripDestinations,
	totalPax,
	isEditMode,
	showBookedPrices,
	startDate,
}: Readonly<CalculatePriceFormProps>) {
	const notifyOnChange = useCallback(
		(values: TVisaServiceInQuote) => {
			onChange?.(values)
		},
		[onChange]
	)

	const initialValues = initialData

	return (
		<Form<TVisaServiceInQuote>
			onSubmit={() => {
				// do nothing
			}}
			initialValues={initialValues}
			mutators={{ ...arrayMutators }}
			subscription={{ submitting: true }}
		>
			{({ handleSubmit }) => {
				return (
					<form noValidate onSubmit={handleSubmit}>
						<Box>
							<ServiceWiseInputFieldsArray
								totalPax={totalPax}
								fieldName={"services"}
								tripDestinations={tripDestinations}
								isEditMode={isEditMode}
								showBookedPrices={showBookedPrices}
								startDate={startDate}
							/>
							<SubmitOnChange onChange={notifyOnChange} />
						</Box>
					</form>
				)
			}}
		</Form>
	)
}

function SubmitOnChange({
	onChange,
}: {
	onChange: (values: TVisaServiceInQuote) => void
}) {
	const { values } = useFormState<TVisaServiceInQuote>({
		subscription: { values: true, valid: true },
	})
	const { set: setNotifyParentTimeout, clear: clearNotifyParentTimeout } =
		useTimeout()

	const onChangeRef = useRef(onChange)
	onChangeRef.current = onChange

	// notify parent
	useEffect(() => {
		setNotifyParentTimeout(() => {
			onChangeRef.current(values)
		}, 500)
		return () => clearNotifyParentTimeout()
	}, [values, setNotifyParentTimeout, clearNotifyParentTimeout])

	return null
}
